import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { AddPackageComponent } from './add-package/add-package.component';
import { PackagesRoutingModule } from './packages-routing.module';
import { PackagesLogComponent } from './packages-log/packages-log.component';
import { AgmCoreModule } from '@agm/core';
import { ViewPackageComponent } from './modals/view-package/view-package.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgxBootstrapMultiselectDropdownModule } from 'ngx-bootstrap-multiselect-dropdown';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageUploadModule } from 'angular2-image-upload';
import { AddPackageDayComponent } from './add-package/add-package-day/add-package-day.component';
import { AddPackagePriceComponent } from './add-package/add-package-price/add-package-price.component';
import { AddPackageActivityComponent } from './add-package/add-package-activity/add-package-activity.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddPackageCancellationPolicyComponent } from './add-package/add-package-cancellation-policy/add-package-cancellation-policy.component';
import { PackageBasicInfoComponent } from './add-package/package-basic-info/package-basic-info.component';
import { PackageScheduleCreationComponent } from './add-package/package-schedule-creation/package-schedule-creation.component';
import { PackageLocationComponent } from './add-package/package-location/package-location.component';
import { PackageScheduleComponent } from './package-schedule/package-schedule.component';
import { PackageCalendarFilterComponent } from './package-schedule/package-calendar-filter/package-calendar-filter.component';
import { ManageDayModalComponent } from './package-schedule/manage-day-modal/manage-day-modal.component';
import { AddImageAltComponent } from './add-image-alt/add-image-alt.component';

import { NgToggleModule } from '@nth-cloud/ng-toggle';

import { DropdownModule } from 'primeng/dropdown';
@NgModule({
  declarations: [
    AddPackageComponent,
    AddImageAltComponent,
    PackagesLogComponent,
    ViewPackageComponent,
    AddPackageDayComponent,
    AddPackagePriceComponent,
    AddPackageActivityComponent,
    AddPackageCancellationPolicyComponent,
    PackageBasicInfoComponent,
    PackageScheduleCreationComponent,
    PackageLocationComponent,
    PackageScheduleComponent,
    PackageCalendarFilterComponent,
    ManageDayModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    PackagesRoutingModule,
    SelectDropDownModule,
    HttpClientModule,
    NgToggleModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBxSEF3Pkhg-mU97PSbLAVNgvMLOJhmBeU',
      libraries: ['places']
    }),
    FullCalendarModule,
    NgbModalModule,
    NgbDropdownModule,
    DropdownModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ImageUploadModule.forRoot()
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    }
  ]
})
export class PackagesModule {}
